// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"redactSidebar_sidebar__ByoWc","isHidden":"redactSidebar_isHidden__mQvgJ"};